import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import { SingletonModule } from './shared/singleton.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthInterceptor } from './shared/auth.interceptor';
import { HttpErrorInterceptor } from './shared/http-error.interceptor';
import { ServiceProviderGatewayInterceptor } from './shared/service-provider-gateway.interceptor';
import { NoopAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { DatabaseEnumsCacheRequestService } from './services/database-enums-cache-request.service';
import { firstValueFrom } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { provideStore } from '@ngxs/store';
import { withNgxsStoragePlugin } from '@ngxs/storage-plugin';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { appRoutes } from './app.routes';

export const frontendAppConfig: ApplicationConfig = {
  providers: [
    /** region ---- ANGULAR ------------------------------------------------- */
    provideAnimations(),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(appRoutes, withPreloading(PreloadAllModules)),
    /** endregion---- ANGULAR ----------------------------------------------- */
    importProvidersFrom([
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http, './assets/i18n/', '.json'),
          deps: [HttpClient]
        }
      }),
      SingletonModule.forRoot(),
      NoopAnimationsModule,
    ]),
    SingletonModule.providers,
    /** region ---- INTERCEPTOR --------------------------------------------- */
    /** Http interceptor providers in outside-in order */
    [
      {
        provide: HTTP_INTERCEPTORS,
        useClass: ServiceProviderGatewayInterceptor,
        multi: true
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: HttpErrorInterceptor,
        multi: true
      }
    ],
    /** endregion ---- INTERCEPTOR ------------------------------------------ */

    /** region ---- NGXS ---------------------------------------------------- */
    provideStore(
      SingletonModule.ngxsStores,
      withNgxsStoragePlugin({
        keys: ['checklistTemplateEntryDuplication']
      })
    ),
    /** endregion - NGXS ---------------------------------------------------- */

    /** region ---- APPLICATION --------------------------------------------- */
    provideAppInitializer(() => {
      const databaseEnumsCacheRequestService = inject(DatabaseEnumsCacheRequestService);
      return databaseEnumsCacheRequestService.loadDatabaseEnumsCache()
        .pipe(
          map((values) => databaseEnumsCacheRequestService.initializeValues(values)
        ));
    })

    /** endregion ---- APPLICATION ------------------------------------------ */
  ]
};
